import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../../lib/cn';
import { Icon, type LucideIcon } from '../ui/icon';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: ReactNode;
  /** Sagt, was hier erscheinen wird, nicht dass etwas fehlt. */
  description?: ReactNode;
  /** Höchstens eine Aktion, meist ein primary Button in Größe lg. */
  action?: ReactNode;
  className?: string;
}

/** Was eine leere Liste sagt: Icon, ein Titel, ein Satz, höchstens eine Aktion. */
export function EmptyState({ icon = Inbox, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-1.5 px-6 py-12 text-center', className)}>
      <Icon icon={icon} size={30} className="mb-2 text-muted-foreground" />
      <div className="t-title">{title}</div>
      {description && <div className="max-w-[360px] text-muted-foreground">{description}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
